import DtoPluvioSituationDayMeasure from './DtoPluvioSituationDayMeasure'

export default class DtoPluvioSituationDays {
    constructor(obj) {
        this.pluvioId = obj.pluvioId
        this.days = obj.days.map(d => new DtoPluvioSituationDayMeasure(d))
    }
}